import { Grid, FormControlLabel, Checkbox } from '@mui/material';

const TabEleven = ({
  setOthers,
  others,
  onClickAll
}) => {
  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <FormControlLabel
          id="others-form-all"
          control={
            <Checkbox
              id="others-all"
              checked={others.every((dash) => dash.value)}
              onClick={(e) => onClickAll(others, 'common', setOthers, e)}
            />
          }
          label="All"
        />
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'Received' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'Sent' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}></Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'Add Feedback' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
    </Grid>
  );
};

export default TabEleven;
